import { css } from '@emotion/react';
import { COLORS2 } from '../Styles';

const ADD_BUTTON_STYLE = css`
  label: ADD_BUTTON_STYLE;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
`;

const ADD_BUTTON_STYLE_SMALL = css`
  label: ADD_BUTTON_STYLE_SMALL;
  width: 22px;
  height: 22px;
`;

const ADD_BUTTON_INNER_STYLE = css`
  label: ADD_BUTTON_INNER_STYLE;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS2.alwaysDark.green};
`;

const ADD_BUTTON_INNER_SMALL_STYLE = css`
  label: ADD_BUTTON_INNER_SMALL_STYLE;
  width: 22px;
  height: 22px;
`;

export const AddButton = ({ onClick, small = false }: { onClick: () => void; small?: boolean }) => (
  <div css={[ADD_BUTTON_STYLE, small && ADD_BUTTON_STYLE_SMALL]} onClick={onClick}>
    <div css={[ADD_BUTTON_INNER_STYLE, small && ADD_BUTTON_INNER_SMALL_STYLE]}>
      <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M10.9991 4.71387V17.2853M17.2848 10.9996H4.71338' stroke='white' strokeWidth='1.57143' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </div>
  </div>
);
